
import { Button } from "@/components/ui/button";
import { AlertTriangle, CheckCircle2, Save } from "lucide-react";

interface ConfirmDialogProps {
  isSubmitting: boolean;
  creditosInsuficientes: boolean;
  onConfirm: () => void;
  actionLabel: string;
}

const ConfirmDialog = ({
  isSubmitting,
  creditosInsuficientes,
  onConfirm,
  actionLabel
}: ConfirmDialogProps) => {
  return (
    <div className="flex flex-col space-y-4">
      {creditosInsuficientes ? (
        <div className="bg-orange-50 border border-orange-200 p-4 rounded-md">
          <div className="flex items-start gap-3">
            <AlertTriangle className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" />
            <div>
              <h3 className="font-medium text-orange-800">Atenção: Créditos insuficientes</h3>
              <p className="text-sm text-orange-700 mt-1">
                O gerador selecionado não possui créditos suficientes para atender o consumo estimado deste cliente.
                Se continuar, o cliente poderá receber apenas parte da energia necessária.
              </p>
            </div>
          </div>
          
          <div className="flex justify-end gap-4 mt-4">
            <Button 
              type="submit"
              onClick={onConfirm}
              disabled={isSubmitting}
              variant="destructive"
              className="bg-orange-600 hover:bg-orange-700"
            >
              {isSubmitting ? 'Salvando...' : 'Confirmar mesmo assim'}
            </Button>
          </div>
        </div>
      ) : (
        <div className="bg-green-50 border border-green-200 p-4 rounded-md">
          <div className="flex items-start gap-3">
            <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
            <div>
              <h3 className="font-medium text-green-800">Tudo certo para cadastrar o cliente</h3>
              <p className="text-sm text-green-700 mt-1">
                O gerador selecionado possui créditos suficientes e está pronto para fornecer energia.
              </p>
            </div>
          </div>
          
          <div className="flex justify-end mt-4">
            <Button 
              type="submit"
              onClick={onConfirm}
              disabled={isSubmitting}
              className="bg-green-600 hover:bg-green-700"
            >
              <Save className="mr-2 h-4 w-4" />
              {isSubmitting ? 'Salvando...' : actionLabel}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmDialog;
